/** Values match API dropdown strings (case-sensitive). */
export const MATCHES_FORMAT_OPTIONS = [
  { value: '', label: 'Select format' },
  { value: 'Limited Overs', label: 'Limited overs' },
  { value: 'Test Match', label: 'Test match' },
  { value: 'Indoor Cricket', label: 'Indoor cricket' },
  { value: 'Box Cricket', label: 'Box cricket' },
] as const;

export const SCORING_METHOD_OPTIONS = [
  { value: '', label: 'Select scoring method' },
  { value: 'Manual', label: 'Manual' },
  { value: 'Paper Scoring', label: 'Paper scoring' },
] as const;

export const SCORING_INTERFACE_OPTIONS = [
  { value: '', label: 'Select interface' },
  { value: 'Mobile', label: 'Mobile' },
  { value: 'Tablet', label: 'Tablet' },
  { value: 'Laptop', label: 'Laptop' },
  { value: 'Paper', label: 'Paper' },
] as const;

export const LANGUAGE_OPTIONS = [
  { value: '', label: 'Select language' },
  { value: 'English', label: 'English' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Tamil', label: 'Tamil' },
  { value: 'Telugu', label: 'Telugu' },
] as const;
